module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/body-texture-bonus.0a55ee09.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/body-texture-bonus.png
// module id = 2531
// module chunks = 11